import BlocksRenderer from '@/components/blocks/blocks-renderer';
import Metadata from '@/components/metadata';
import { getHome } from '@/lib/datocms/home';
import { GetServerSidePropsContext } from 'next';

export default function HomePage({ data }: { data: any }) {
  return (
    <>
      <Metadata data={data} />
      <BlocksRenderer blocks={data?.page?.blocks} />
    </>
  );
}

export async function getServerSideProps({ locale }: GetServerSidePropsContext) {
  const data = await getHome(locale || 'en');

  return {
    props: {
      data,
    },
  };
}
